import React, { useEffect, useRef, useState } from 'react'
import { useRetorikStore } from '../Contexts/RetorikContext'
import { useSpeechStore } from '../Contexts/SpeechContext'
import { useLocaleStore } from '../Contexts/LocaleContext'
import { useDirectlineStore } from '../Contexts/DirectlineContext'

import { Mode, RecognitionState } from '../../models/enums'
import Counter from './Utils/Counter'

const CounterAttachment = (): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const mode = useSpeechStore((state) => state.mode)
  const placeHolder = useRetorikStore((state) => state.sendBoxPlaceHolder)
  const delay = useRetorikStore((state) => state.submitDelayBeforeSendingMessage)
  const speechInterims = useSpeechStore((state) => state.lastRecognitionInterim)
  const recognitionState = useSpeechStore((state) => state.activeRecognitionState)
  const { setActiveRecognitionState, setMode } = useSpeechStore((state) => state.actions)
  const sendMessage = useDirectlineStore((state) => state.actions.sendMessage)

  const [displayCounter, setDisplayCounter] = useState<boolean>(false)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    setDisplayCounter(false)
  }, [placeHolder, delay])

  useEffect(() => {
    if (delay && recognitionState === RecognitionState.Closing && speechInterims) {
      setDisplayCounter(true)
      timerRef.current = setTimeout(() => {
        sendMessage(speechInterims)
        setActiveRecognitionState(RecognitionState.Closed)
      }, delay * 1000)
    }

    return () => {
      timerRef.current && clearTimeout(timerRef.current)
    }
  }, [delay, speechInterims, recognitionState])

  const handleButtonClick = (): void => {
    timerRef.current && clearTimeout(timerRef.current)
    setActiveRecognitionState(RecognitionState.Closed)
    setMode(Mode.text)
  }

  return mode === Mode.vocal && (recognitionState === RecognitionState.Closing || recognitionState === RecognitionState.Listening) ? (
    <div className='rf-w-full rf-h-full rf-p-4 rf-pb-8 rf-flex rf-flex-col rf-items-center rf-bg-cardFrameBackground rf-gap-4 rf-rounded'>
      {/* Placeholder as title */}
      {placeHolder && <div className='rf-w-full rf-subtitle-size-auto rf-text-center rf-text-cardFrameText rf-font-bold'>{placeHolder}</div>}

      {/* Correction button */}
      {displayCounter ? (
        /* Counter + button */
        <React.Fragment>
          {delay && <Counter delay={delay} />}
          <button className='rf-card-button' onClick={handleButtonClick}>
            {translation.anghello.correct}
          </button>
        </React.Fragment>
      ) : (
        <div className='rf-w-full rf-text-medium-size-auto rf-text-center rf-text-cardButtonTextDefault'>{translation.anghello.listening}</div>
      )}
    </div>
  ) : (
    <React.Fragment />
  )
}

export default CounterAttachment
